import { render, staticRenderFns } from "./BotaoAjuda.vue?vue&type=template&id=362e311a&"
import script from "./BotaoAjuda.vue?vue&type=script&lang=js&"
export * from "./BotaoAjuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports